module.exports = __webpack_public_path__ + "img/img_2.0c0fe1cf.png";